import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [loading, setLoading] = useState(true);

    const fetchUser = async () => {
        try {
            const res = await axios.get('/api/current_user');
            setCurrentUser(res.data);
            if (res.data && res.data.email === 'ms.guptahardik@gmail.com') {
                setIsAdmin(true);
            } else {
                setIsAdmin(false);
            }
        } catch (error) {
            console.error('Error fetching user context:', error);
            setCurrentUser(null);
            setIsAdmin(false);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUser();
    }, []);

    const login = () => {
        const currentPath = window.location.href;
        const baseUrl = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5002';
        window.location.href = `${baseUrl}/auth/google?returnTo=${encodeURIComponent(currentPath)}`;
    };

    const logout = () => {
        const currentPath = window.location.href;
        const baseUrl = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5002';
        window.location.href = `${baseUrl}/api/logout?returnTo=${encodeURIComponent(currentPath)}`;
    };

    return (
        <AuthContext.Provider value={{ currentUser, isAdmin, loading, login, logout, fetchUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
